/**
 * @generated SignedSource<<6e4e3b5a2ddcad288b5bd2e701634e49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatChannelFragment$data = {
  readonly externalChannelId: string;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelEditMessageFragment" | "ChatChannelMessageFragment" | "ChatChannel_EmptyStateIndicatorFragment">;
  readonly " $fragmentType": "ChatChannelFragment";
};
export type ChatChannelFragment$key = {
  readonly " $data"?: ChatChannelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalChannelId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannel_EmptyStateIndicatorFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelMessageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelEditMessageFragment"
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};

(node as any).hash = "bedd200d57517e5f5c0aa4ca41611b78";

export default node;
